const app = {
    state: {
        userInfo:null,
        isPass:null,
        device: 'desktop'
    },
    mutations: {
        UPDATE_ISPASS(state, data) {
            state.isPass = data;
        },
        UPDATE_USER(state, data) {
            state.userInfo = data;
        },
        TOGGLE_DEVICE: (state, device) => {
            state.device = device
        },
    },
    actions: {
        updateUser({ commit }, datas) {
            commit('UPDATE_USER', datas)
        },
        toggleDevice({ commit }, device) {
            commit('TOGGLE_DEVICE', device)
        },
    }
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js